export const selectWebinars = state => state.informatives.webinars
